import { useLocation } from 'react-router-dom';
import { User } from '@upstart/harmony/lib/legos/userTypes';
import { Dealer } from '@upstart/harmony/lib/legos/dealerTypes';
import { canUserAccessFniPresentFlow } from '@upstart/harmony/lib/user-utils';
import { FNI_PRESENT_FLOW_QUERY_PARAM } from '../containers/PencilEditor/types';

/**
 * Determines if fni present is enabled for current flow
 * @param currentUser: current user
 * @param dealer: dealer
 * @param ignoreQueryParam: whether to ignore check for fniPresentFlow param. Not required for entry point to flow
 */
export const useFniPresent = ({
  currentUser,
  dealer,
  ignoreQueryParam,
}: {
  currentUser?: User;
  dealer?: Dealer;
  ignoreQueryParam?: boolean;
}): boolean => {
  const location = useLocation();

  const queryParamEnabled = ignoreQueryParam
    ? true
    : new URLSearchParams(location.search).get(FNI_PRESENT_FLOW_QUERY_PARAM) ===
      'true';

  const isFniPresentFlowEnabled =
    currentUser &&
    canUserAccessFniPresentFlow(currentUser, dealer) &&
    queryParamEnabled;

  return !!isFniPresentFlowEnabled;
};
